import { Component, DOCUMENT, DestroyRef, OnInit, inject, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { RouterOutlet } from '@angular/router';
import { SwUpdate } from '@angular/service-worker';

import { filter } from 'rxjs';

import { MstDialogComponent } from '@app/components/feedback/dialog/dialog.component';
import { ButtonDirective } from '@app/components/general/button/button.directive';

import { VERSION } from '@env/version';

@Component({
    selector: 'mst-root',
    imports: [RouterOutlet, MstDialogComponent, ButtonDirective],
    templateUrl: './app.html',
    styleUrl: './app.scss',
})
export class App implements OnInit {
    protected readonly title = signal('mst-training');
    protected readonly updateAvailable = signal(false);

    private readonly document = inject<Document>(DOCUMENT);
    private readonly swUpdate = inject(SwUpdate);
    private readonly destroyRef = inject(DestroyRef);

    ngOnInit(): void {
        this.setupAppVersion();
        this.listenForUpdates();
    }

    protected applyUpdate(): void {
        window.location.reload();
    }

    protected dismissUpdate(): void {
        this.updateAvailable.set(false);
    }

    private setupAppVersion(): void {
        const version = this.document.createElement('script');
        version.type = 'text/javascript';
        version.text = `window.appVersion = function() { return '${VERSION.version} - ${VERSION.hash}' }`;
        this.document.body.appendChild(version);
    }

    private listenForUpdates(): void {
        if (!this.swUpdate.isEnabled) return;

        this.swUpdate.versionUpdates
            .pipe(
                filter((event) => event.type === 'VERSION_READY'),
                takeUntilDestroyed(this.destroyRef),
            )
            .subscribe(() => {
                this.updateAvailable.set(true);
            });
    }
}
